const BANNER = {
  TITLE:
    'somos uma <b>corretora de seguros,</b> trabalhamos com as <b>principais marcas</b>',
  IMAGE:
    'https://www.itau.com.br/assets/dam/publisher/01_itau/09_Seguros/01_campanha1/assets/home/banner_home_loja_seguros.png',
};

export default BANNER;
